<script>
</script>

<main>
    <p>créé avec <a href="https://svelte.dev/">Svelte</a></p>
    <p>déployé avec <a href="https://dash.cloudflare.com/">Cloudflare</a></p>
    <p>
        Par
        <b>Pierre Colin</b>
    </p>
</main>

<style>
    main {
        border-top: 1px solid #222222;
        width: 100%;
        height: 10vh;
        display: flex;
        justify-content: space-around;
        align-items: center;
        text-align: center;
    }
</style>
